/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter used to order an object that has properties pointing to objects.
 */
angular
  .module('filters.objectOrderBy', [])
  /**
   * Filter used for ordering objects by a property.
   *
   * @param {Object} - An object with property values to be sorted. Each property of
   *   the object should point to an object.
   * @param {String} - The property to sort on.
   * @param {Boolean} - Reverse the ordering
   * @returns {Array[Object]} - A sorted object array.
   */
  .filter('objectOrderBy', function () {
    return function (input, attribute, reverse) {
      var objArray = [];

      if (!angular.isObject(input)) {
        return input;
      }

      //eslint-disable-next-line guard-for-in
      for (var objectKey in input) {
        objArray.push(input[objectKey]);
      }

      objArray.sort(function (a, b) {
        a = parseInt(a[attribute], 10) || a[attribute];
        b = parseInt(b[attribute], 10) || b[attribute];

        if (angular.isNumber(a) && angular.isNumber(b)) {
          return a - b;
        } else {
          return a.localeCompare(b);
        }
      });

      if (reverse) {
        objArray.reverse();
      }
      return objArray;
    };
  });
